import { ascend, pathOr, prop, sortWith } from 'ramda';

import { useAppSelector } from '@/shared/hooks';
import { getName } from '@/shared/lib';
import { SelectProps } from '@/shared/ui';

import { OrganizationMember, organizationModel } from '@/entities/organization';
import { userModel } from '@/entities/user';

export const useOrganizationUsersOptions = (
  currentUserID: string,
): SelectProps['options'] => {
  const treatingDoctors = useAppSelector(
    organizationModel.selectors.selectTreatingDoctors,
  );
  const userLocale = useAppSelector(userModel.selectors.selectUserLocale);

  const sortedUsers: OrganizationMember[] = sortWith<OrganizationMember>(
    [
      ascend((user) => (user.UserID === currentUserID ? 0 : 1)),
      ascend(pathOr('', ['PersonalData', 'LastName'])),
      ascend(pathOr('', ['PersonalData', 'FirstName'])),
      ascend(prop('UserID')),
    ],
    treatingDoctors ?? [],
  );

  return sortedUsers.map((user) => ({
    value: user.UserID ?? '',
    label: getName(user.PersonalData?.FirstName, user.PersonalData?.LastName, {
      userLocale,
    }),
  }));
};
